import accountHelper from "@/utils/helpers/account";
import dateHelper from "@/utils/helpers/date";
import freshdesk from "@/utils/helpers/freshdesk";
import buildLink from "@/api/helpers/freshdesk/buildLink";

function createCancellationBody(payload, isAbsence) {
  let { order, Data, tags } = payload;
  return {
    email: order.customer.account.email,
    subject: createCancellationSubject(order.customer, order.schedule_event),
    tags: ["Automatico", "Cancelamento"].concat(tags),
    description:
      createCancellationDescription(order, Data, isAbsence) +
      createRefundDataDescription(Data),
    priority: freshdesk.getTicketPriority("high"),
    status: freshdesk.getTicketStatusCode("open"),
    group_id: freshdesk.getGroupIds("customer_experience"),
    type: "[sou cliente] Reagendar/Cancelar uma limpeza"
  };
}

function createCreditHoursBody(payload, isAbsence) {
  let { order, tags } = payload;
  return {
    email: order.customer.account.email,
    subject: createCancellationSubject(order.customer, order.schedule_event),
    tags: ["Automatico", "Cancelamento", "Horas de crédito"].concat(tags),
    description: createCreditHoursDescription(order, isAbsence),
    priority: freshdesk.getTicketPriority("high"),
    status: freshdesk.getTicketStatusCode("open"),
    group_id: freshdesk.getGroupIds("customer_experience"),
    type: "[sou cliente] Reagendar/Cancelar uma limpeza"
  };
}

const createCancellationSubject = (customer, schedule_event) =>
  `Solicitação de Cancelamento - ${accountHelper.fullName(
    customer.account
  )} (${dateHelper.getDate(schedule_event.starts_at)})`;

const createCancellationDescription = (order, Data, isAbsence) =>
  `Olá, meu nome é ${buildLink.customer(order.customer)}, ${absencePrefix(
    isAbsence
  )}
   cancelar o meu pedido!</br></br><b>Dados do pedido:</b></br><b>Link do pedido:</b> ${buildLink.order(
     order.id
   )}</br><b>Nome do usuário:</b> ${buildLink.customer(
    order.customer
  )}</br>${checkDocumentType(order)}</br><b>Tipo de pagamento:</b> ${
    Data.paymentType
  }</br><b>Motivo do cancelamento:</b> ${Data.why}`;

const createRefundDataDescription = Data =>
  Data.paymentType === "Boleto"
    ? `</br></br>Dados para o reembolso de boleto:</br>
            <b>Nome do banco:</b> ${Data.bank}</br>
            <b>Agência:</b> ${Data.agency}</br>
            <b>Conta:</b> ${Data.accountNumberWithDigit}
            `
    : " ";

const createCreditHoursDescription = (order, isAbsence) =>
  `Olá, meu nome é ${buildLink.customer(order.customer)} ${absencePrefix(
    isAbsence
  )} cancelar o meu pedido e deixar minhas horas como crédito para utilizar em outra data!</br></br>
    <b>Dados do pedido:</b></br>
    <b>Link do pedido:</b> ${buildLink.order(order.id)}</br>
    <b>Nome do usuário:</b> ${buildLink.customer(order.customer)}</br>
    `;

const checkDocumentType = order => {
  return order.customer_type == "Physical"
    ? `<b>CPF:</b> ${order.customer.cpf}`
    : `<b>CNPJ:</b> ${order.customer.cnpj}`;
};

const absencePrefix = isAbsence => {
  return isAbsence
    ? "a profissional não compareceu a limpeza que eu contratei. Devido a essa falta, quero"
    : "agendei uma limpeza com o aplicativo Donamaid e gostaria de ";
};

export default {
  createCancellationBody,
  createCreditHoursBody
};



// WEBPACK FOOTER //
// ./src/api/helpers/freshdesk/cancellation.js